import { render, staticRenderFns } from "./FraudAlertCard.vue?vue&type=template&id=84998f56&scoped=true"
import script from "./FraudAlertCard.vue?vue&type=script&lang=js"
export * from "./FraudAlertCard.vue?vue&type=script&lang=js"
import style0 from "./FraudAlertCard.vue?vue&type=style&index=0&id=84998f56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84998f56",
  null
  
)

export default component.exports